import React from 'react';
import { useTranslation } from 'react-i18next';
import GoogleMap from 'google-map-react';

import { getDefaultLanguage } from '@klp/layout/Sidebar/config';

import './GoogleMaps.scss';
import { GoogleMapsRegions, getGoogleMapsApiKey } from './config';
import SvgMarker from './GoogleMapsMarker.svg';

interface IGoogleMapsProps {
    latitude: number;
    longitude: number;
    zoom?: number;
}

const Marker: React.FC<{ latitude: number; longitude: number }> = ({
    latitude,
    longitude,
}) => (
    <img
        alt="Google Maps Marker"
        src={SvgMarker}
        className="GoogleMapsMarker"
        onClick={() =>
            window.open(
                `https://www.google.com/maps/place/${latitude},${longitude}`,
                '_blank',
            )
        }
    />
);

export const GoogleMaps: React.FC<IGoogleMapsProps> = ({
    zoom = 15,
    latitude,
    longitude,
}) => {
    const { i18n } = useTranslation();

    return (
        <GoogleMap
            style={{ width: '100%', height: '100%' }}
            bootstrapURLKeys={{
                key: getGoogleMapsApiKey(),
                language: i18n.language,
                region: GoogleMapsRegions[
                    i18n.language || getDefaultLanguage()
                ],
            }}
            defaultCenter={{
                lat: latitude,
                lng: longitude,
            }}
            defaultZoom={zoom}
        >
            <Marker latitude={latitude} longitude={longitude} />
        </GoogleMap>
    );
};
